import {
  SearchProduct as ApiSearchProduct,
  ShowProduct as ApiShowProduct,
  SearchProduct as ApiRelatedProduct,
} from "@/api/products";
import { SearchCategory as ApiSearchCategory } from "@/api/categories";
import { SearchBrand as ApiSearchBrand } from "@/api/brands";
import { SearchGroup as ApiSearchGroup } from "@/api/groups";
import { genders, states } from "@/config/constants";

const convert = (products) => {
  return products.map((product) => {
    if (product.images && product.images.length) {
      let slides = [];

      let cover = "";
      cover = product.base_url + product.images[0].url;

      slides = product.images.map((img) => product.base_url + img.url);
      return { ...product, cover, images: slides };
    }
    return product;
  });
};

const state = {
  categories: [],
  brands: [],
  groups: [],
  genders: [...genders],
  states: [...states],
  relatedProducts: [],
  products: [],
  product: {},
  payload: {},
  isLoading: false,
};

const getters = {
  getAllProducts: (state) => state.products,
};

const mutations = {
  setLoadingState(state, playload) {
    state.isLoading = playload;
  },

  resetStore(state) {
    return (state.categories = []), (state.products = []);
  },

  setCategories(state, categories) {
    state.categories = categories;
  },

  setBrands(state, brands) {
    state.brands = brands;
  },

  setGroups(state, groups) {
    state.groups = groups;
  },

  setProducts(state, products) {
    state.products = products;
  },

  setProduct(state, product) {
    state.product = product[0];
  },

  setRelatedProducts(state, payload) {
    state.relatedProducts = payload;
  },
  mergeProducts(state) {
    state.payload.page++;
    ApiSearchProduct(payload)
      .then((response) => {
        response.data.forEach((item) => {
          state.products.push(item);
        });
      })
      .catch(() => {
        this.loading = false;
      });
  },

  filterProducts(state, category) {
    const products = state.products.filter(
      (product) => product.category_id == category.id
    );
    state.products = products;
  },

  setPayload(state, payload) {
    state.payload = payload;
  },
};

const actions = {
  getCategories(context) {
    ApiSearchCategory()
      .then((response) => {
        context.commit("setCategories", response.data);
      })
      .catch(() => {});
  },

  getBrands(context) {
    ApiSearchBrand()
      .then((response) => {
        context.commit("setBrands", response.data);
      })
      .catch(() => {});
  },

  getGroups(context) {
    ApiSearchGroup()
      .then((response) => {
        context.commit("setGroups", response.data);
      })
      .catch(() => {});
  },

  getRelatedProducts(context, payload) {
    ApiSearchProduct(payload)
      .then((response) => {
        context.commit("setRelatedProducts", response.data);
      })
      .catch(() => {});
  },

  getProducts(context, payload) {
    context.commit("setLoadingState", true);
    context.commit("setPayload", payload);
    ApiSearchProduct(payload)
      .then((response) => {
        context.commit("setLoadingState", false);
        context.commit("setProducts", convert(response.data));
      })
      .catch(() => {});
  },

  getProduct(context, payload) {
    context.commit("setLoadingState", true);
    ApiShowProduct({ id: payload })
      .then((response) => {
        context.commit("setLoadingState", false);
        context.commit("setProduct", convert([response.data]));
      })
      .catch(() => {
        context.commit("setLoadingState", true);
      });

    ApiSearchProduct({ page: 1 })
      .then((response) => {
        const relatedProducts = response.data.filter((x) => x.id !== payload);
        context.commit("setRelatedProducts", convert(relatedProducts));
      })
      .catch(() => {});
  },

  mergeProducts(context) {
    context.commit("mergeProducts");
  },

  filterProducts(context, category) {
    context.commit("filterProducts", category);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
